import React from "react"
import { TwitchUser } from "../../models/TwitchUser"
import { Router } from "../../utils/Router"
import { UserReader } from "../../utils/UserReader"

interface IProps{
    readonly username: string
}

interface IState{
    readonly imgSrc: string
}

export class UserAvatar extends UserReader<IProps, IState>{
    constructor(props: IProps){
        super(props, {
            imgSrc: Router.getBaseUrl() + "images/default_user.png"
        })
    }

    afterRead = (user: TwitchUser) => this.setState({ imgSrc: user.profile_image_url })

    getUsername = () => this.props.username

    render = () => <img src={this.state.imgSrc} className="user-avatar" alt={"user-avatar_" + this.props.username} />
}